import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-buy-gray",
  "use": "icon-buy-gray-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-buy-gray\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path opacity=\".465\" d=\"M0 0h20v20H0z\" />\n        <path d=\"M16 5.333 20 20H0L4 5.333h12zM14.727 7H5.272L2.18 18.333h15.639L14.727 7zm-1.394 5v1.667L10 15l-3.333-1.333V12l3.341 1.333L13.333 12zm-8-9 4.675-1.333L14.667 3V1.333L10 0 5.333 1.333V3z\" fill=\"#b5b5b5\" fill-rule=\"nonzero\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol